import { createFileRoute } from "@tanstack/react-router";

import { fetchPoliciesOther } from "@/loaders/policies";
import Policies from "@/pages/policies";

export const Route = createFileRoute("/policies/$company/$location/other")({
  component: OtherPolicyPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return { meta: [{ title: loaderData.title }] };
  },
  loader: ({ params }) =>
    fetchPoliciesOther({
      data: { company: params.company, location: params.location },
    }),
});

function OtherPolicyPage() {
  const data = Route.useLoaderData();
  return <Policies {...data} />;
}
